module.exports = __webpack_public_path__ + "static/media/venue.2c1df459.svg";